import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "mt-5 px-3" }

import HeaderHjpTable from '@/views/components/header/HeaderHjpTable.vue'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import OpenedList from './components/lists/OpenedList.vue'
import ClosedList from './components/lists/ClosedList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const endpoint = 'transaction/v2/TransactionPps'
const headerTitle = ref('Daftar Setoran Sisa Snack')
const positionTabs = ref(0)
const tabHeader = ref([
  { title: 'Belum Approve', value: 0, hasCount: true, count: 0 },
  { title: 'Sudah Approve', value: 1, hasCount: true, count: 0 }
])
const store = useStore()

const tabsChange = (val: any) => {
  positionTabs.value = val
}

const getTabsdataCount = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpoint}/NonCash/Completed?status=CompletedNonCash`).then((response) => {
    const { error, count } = response
    if (!error) {
      tabHeader.value[0].count = count
    }
  })

  await apiUseCase.get(`${endpoint}/NonCash/Completed?status=CompletedSnack`).then((response) => {
    const { error, count } = response
    if (!error) {
      tabHeader.value[1].count = count
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  getTabsdataCount()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-list" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderHjpTable, {
            titleHeader: headerTitle.value,
            showSearch: false,
            showAddBtn: false
          }, null, 8, ["titleHeader"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(HjpTabView, {
          onTabsChange: tabsChange,
          tabHeader: tabHeader.value
        }, null, 8, ["tabHeader"]),
        _createElementVNode("div", _hoisted_2, [
          (positionTabs.value === 0)
            ? (_openBlock(), _createBlock(OpenedList, { key: 0 }))
            : (positionTabs.value === 1)
              ? (_openBlock(), _createBlock(ClosedList, { key: 1 }))
              : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => []),
      _: 1
    })
  ]))
}
}

})